/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./carBuy.vue?vue&type=template&id=52655224&scoped=true&"
import script from "./carBuy.vue?vue&type=script&lang=js&"
export * from "./carBuy.vue?vue&type=script&lang=js&"
import style0 from "./carBuy.vue?vue&type=style&index=0&id=52655224&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52655224",
  null
  
)

export default component.exports